import React from 'react';
import { t } from 'localization';
import IconPickAddress from 'assets/static/images/ic_sender.svg';
import IconDropAddress from 'assets/static/images/ic_reciver.svg';
import 'components/SideBlock/ShippingAddress/ShippingAddress.scss';
import { Block } from 'components/Block';

export const ShippingAddress = (props) => {
  const { data } = props;
  const {
    pick_address_info: pickAddressInfo,
    drop_address_info: dropAddressInfo,
    sender_info: senderInfo,
    recipient_info,
    receiver_info,
    recipient_labels: recipientLabels = [],
  } = data;
  const receiverInfo = recipient_info || receiver_info;

  const renderOldAddress = (address) => {
    return (
      <div div style={{ marginTop: 4, marginLeft: 12, fontSize: 12, color: 'rgba(0, 0, 0, 0.65)' }}>{`Địa chỉ cũ: ${address}`}</div>
    )
  }

  return (
    <Block title={t('shipping_address')}>
      <div className='shipping-address'>
        <div className='sender'>
          <img className='sender_icon' src={IconPickAddress} alt='' />
          <div>
            <div className='sender-address'>{pickAddressInfo?.address}</div>
            {pickAddressInfo?.old_address && (
              renderOldAddress(pickAddressInfo?.old_address)
            )}
            <div className='sender-info'>
              <div>{`${senderInfo.name} - ${senderInfo?.phone}`}</div>
            </div>
          </div>
        </div>
        <div className='receiver'>
          <img className='receiver_icon' src={IconDropAddress} alt='' />
          <div>
            <div className='receiver-address'>{dropAddressInfo?.address}</div>
            {dropAddressInfo?.old_address && (
              renderOldAddress(dropAddressInfo?.old_address)
            )}
            <div className='receiver-info'>
              {receiverInfo && (<div>{`${receiverInfo.name} - ${receiverInfo.phone}`}</div>)}
            </div>
          </div>
        </div>
        <div className='recipient-label'>
          {recipientLabels.map((item, index) => (
            <span key={index} className='recipient-item'>{item}</span>
          ))}
        </div>
      </div>
    </Block>
  );
};
